(() => {
  const key = 'mayLondonMeasurements.v1';
  const parse = text => { try { return JSON.parse(text || 'null'); } catch (_) { return null; } };
  function init(scope = document) {
    scope.querySelectorAll('[data-fit-guide]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const data = parse(root.querySelector('[data-fit-data]').textContent) || {};
      const strings = parse(root.querySelector('[data-fit-strings]').textContent) || {};
      const decoder = document.createElement('textarea');
      Object.keys(strings).forEach(key => { decoder.innerHTML = strings[key]; strings[key] = decoder.value; });
      const form = root.querySelector('[data-measurement-form]');
      const fields = [...form.querySelectorAll('input[name]')];
      const remember = form.querySelector('[data-measurements-remember]');
      const status = form.querySelector('[data-measurements-status]');
      const regions = root.querySelector('[data-fit-region]');
      const locale = document.documentElement.lang || 'en';
      let unit = 'metric';
      const measureKeys = ['height', 'bust', 'waist', 'hips', 'shoulders', 'length'];
      const convert = (value, name, from, to) => from === to || !measureKeys.includes(name) && name !== 'weight' ? value : value * (from === 'metric' ? 1 / (name === 'weight' ? .45359237 : 2.54) : name === 'weight' ? .45359237 : 2.54);
      const number = value => new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value);
      const cell = (tag, value) => { const el = document.createElement(tag); el.textContent = value; return el; };
      const range = value => Array.isArray(value) && value.length === 2 && value.every(n => Number.isFinite(n) && n > 0 && n < 400) ? value.map(n => number(convert(n, 'bust', 'metric', unit))).join(' - ') : Number.isFinite(value) && value > 0 && value < 400 ? number(convert(value, 'bust', 'metric', unit)) : '';
      const tables = () => {
        let hasChart = false;
        for (const kind of ['body', 'garment']) {
          const container = root.querySelector(`[data-fit-chart="${kind}"]`);
          const rows = Array.isArray(data[kind]) ? data[kind].slice(0, 80).filter(row => row && typeof row.size === 'string') : [];
          container.replaceChildren();
          const fallback = container.nextElementSibling;
          if (fallback) fallback.hidden = rows.length > 0;
          if (!rows.length) continue;
          hasChart = true;
          const columns = measureKeys.filter(name => rows.some(row => range(row[name])));
          const table = document.createElement('table');
          const head = table.createTHead().insertRow();
          const hasRegion = rows.some(row => typeof row[regions.value] === 'string' || typeof row[regions.value] === 'number');
          const headers = [strings.size, ...(hasRegion ? [regions.value.toUpperCase()] : []), ...columns.map(name => `${strings[name]} (${unit === 'metric' ? 'cm' : 'in'})`)];
          headers.forEach(label => { const th = cell('th', label); th.scope = 'col'; head.append(th); });
          const body = table.createTBody();
          for (const row of rows) {
            const tr = body.insertRow(); const label = cell('th', row.size); label.scope = 'row'; tr.append(label);
            if (hasRegion) tr.append(cell('td', String(row[regions.value] ?? '')));
            columns.forEach(name => tr.append(cell('td', range(row[name]))));
          }
          container.append(table);
        }
        root.querySelector('[data-fit-region-wrap]').hidden = !hasChart;
        const model = root.querySelector('[data-fit-model]'); model.replaceChildren(); model.hidden = true;
        if (data.model && typeof data.model.size === 'string') {
          model.hidden = false; model.append(cell('h3', strings.model));
          const dl = document.createElement('dl'); dl.append(cell('dt', strings.size), cell('dd', data.model.size));
          for (const name of ['height', 'bust', 'waist', 'hips']) if (range(data.model[name])) dl.append(cell('dt', strings[name]), cell('dd', `${range(data.model[name])} ${unit === 'metric' ? 'cm' : 'in'}`));
          model.append(dl);
        }
      };
      const characteristics = root.querySelector('[data-fit-characteristics]');
      for (const [name, options] of [['fit', ['slim', 'regular', 'relaxed', 'oversized']], ['stretch', ['none', 'slight', 'medium', 'high']]]) {
        if (!options.includes(data[name])) continue;
        characteristics.hidden = false;
        const group = document.createElement('div'); group.append(cell('h3', strings[name]));
        const labels = document.createElement('div'); labels.className = 'fit-guide__scale';
        options.forEach(value => { const label = cell('span', strings[value]); if (value === data[name]) { label.className = 'is-current'; label.setAttribute('aria-current', 'true'); } labels.append(label); });
        group.append(labels); characteristics.append(group);
      }
      const updateUnits = next => {
        for (const input of fields) {
          if (input.type === 'number' && input.value !== '') input.value = String(Math.round(convert(Number(input.value), input.name, unit, next) * 100) / 100);
          const suffix = root.querySelector(`[data-measurement-unit="${input.name}"]`);
          suffix.textContent = measureKeys.includes(input.name) ? next === 'metric' ? 'cm' : 'in' : input.name === 'weight' ? next === 'metric' ? 'kg' : 'lbs' : '';
          if (input.type === 'number') { input.max = input.name === 'age' ? '120' : String(convert(300, input.name, 'metric', next)); input.step = input.name === 'age' ? '1' : 'any'; }
        }
        unit = next; tables();
      };
      root.querySelectorAll('[data-fit-unit]').forEach(input => input.addEventListener('change', () => updateUnits(input.value)));
      regions.addEventListener('change', tables);
      const tabs = [...root.querySelectorAll('[data-fit-tab]')];
      const activate = tab => {
        tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        root.querySelectorAll('[data-fit-panel]').forEach(panel => { panel.hidden = panel.dataset.fitPanel !== tab.dataset.fitTab; });
      };
      tabs.forEach(tab => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault(); const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[index]); tabs[index].focus();
        });
      });
      try {
        const saved = parse(localStorage.getItem(key));
        if (saved?.version === 1 && saved.values && Date.now() - saved.updatedAt < 31536000000) {
          for (const input of fields) { const value = saved.values[input.name]; if (input.type === 'number' && Number.isFinite(value) && value > 0 && value <= 300 || input.type === 'text' && typeof value === 'string' && value.length <= 8) input.value = String(value); }
          remember.checked = true;
        }
      } catch (_) { /* Storage is optional. */ }
      updateUnits('metric');
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        if (!fields.some(input => input.value.trim())) { status.textContent = strings.empty; return; }
        const values = {};
        fields.forEach(input => { if (input.value.trim()) values[input.name] = input.type === 'number' ? convert(Number(input.value), input.name, unit, 'metric') : input.value.trim(); });
        try {
          if (remember.checked) localStorage.setItem(key, JSON.stringify({ version: 1, values, updatedAt: Date.now() }));
          else localStorage.removeItem(key);
          status.textContent = remember.checked ? strings.saved : strings.session;
        } catch (_) { status.textContent = strings.storage_error; }
      });
      remember.addEventListener('change', () => { if (!remember.checked) { try { localStorage.removeItem(key); } catch (_) {} } });
      form.querySelector('[data-measurements-clear]').addEventListener('click', () => {
        fields.forEach(input => { input.value = ''; }); remember.checked = false;
        try { localStorage.removeItem(key); status.textContent = strings.cleared; } catch (_) { status.textContent = strings.storage_error; }
      });
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('maylondon:fit-guide:load', event => init(event.target));
})();
